<template>
  <div>
    <b-row>
      <b-col sm="12" md="5">
        <b-card no-body>
          <b-card-body class="px-1 pb-0">
            <b-row>
              <b-col sm="2" class=" align-self-center" style="margin-top:-22px; margin-bottom: -18px">
                <b-button-group>
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      id="act_semAct"
                      :disabled="loading"
                      v-b-tooltip.hover="'Actualizar Tabla'"
                      @click="obtenerHistorialCosechadores"
                  >
                    <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
                  </b-button>

                  <!--
                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="descargarRegistros"
                      :disabled="loading2"
                      id="btn_descargar_registros"
                      v-b-tooltip.hover="'Descargar Excel'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-excel"/>
                  </b-button>

                  <b-button
                      variant="gradient-primary"
                      size="sm"
                      @click="descargarPdf"
                      :disabled="loading3"
                      id="btn_descargar_pdf"
                      v-b-tooltip.hover="'Descargar Pdf'"
                  >
                    <font-awesome-icon v-if="loadingSAM" icon="fa-solid fa-arrows-rotate" spin/>
                    <font-awesome-icon v-else icon="fa-solid fa-file-pdf"/>
                  </b-button>
                  -->

                </b-button-group>
              </b-col>
              <!-- <b-col md="2"></b-col> -->
              <b-col sm="3" class=" align-self-center" style="margin-bottom: -18px">

                <b-form-group
                    label="Fecha de Inicio"
                    label-for="fecha_inicio"
                >
                  <b-form-datepicker
                      id="fecha_inicio"
                      v-model="fecha_inicio"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      :hide-header=true
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      size="sm"
                      close-button
                      name="fecha_inicio"
                      placeholder="Fecha de Inicio"
                      @input="obtenerHistorialCosechadores"
                  />
                </b-form-group>

                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;"></span><br>

              </b-col>

              <b-col sm="3" class=" align-self-center" style="margin-bottom: -18px">

                <b-form-group
                    label="Fecha Fin"
                    label-for="fecha_fin"
                >
                  <b-form-datepicker
                      id="fecha_fin"
                      v-model="fecha_fin"
                      :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                      :hide-header=true
                      start-weekday="1"
                      v-bind="labels || {}"
                      today-button
                      reset-button
                      size="sm"
                      close-button
                      name="fecha_fin"
                      placeholder="Fecha Fin"
                      @input="obtenerHistorialCosechadores"
                  />
                </b-form-group>

                <span class="font-weight-bolder font-medium-3" style="vertical-align: -webkit-baseline-middle!important;"></span><br>

              </b-col>

              <b-col sm="4" class=" align-self-center" style="margin-top:-28px; margin-bottom: -18px">
                <b-form-group
                    label="Buscar por:"
                    label-for="evento"
                >
                  <b-input-group size="md">
                      <b-form-input
                        id="evento"
                        v-model="evento"
                        name="evento"
                        size="sm"
                      />
                      <b-input-group-append>
                        <b-button
                            variant="gradient-secondary"
                            :disabled="!evento"
                            @click="itemsFiltro = items; evento = ''"
                            size="sm"
                        >
                          Borrar
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- TABLA DE ENTREGA -->
          <b-table
              ref="tableSemanaActual"
              responsive
              hover
              outlined
              small
              sticky-header="58vh"
              class="position-relative tablaferti"
              :items="items"
              :fields="fields"
              :filter="evento"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="cPaginacion"
              :busy="loading"
              show-empty
              empty-text="No se encontraron datos en esta tabla."
              emptyFilteredText="No se encontraron datos con los parámetros ingresados."
          >
            <template #table-busy>
              <div class="text-center text-dark my-1">
                <b-spinner class="align-middle"></b-spinner> &emsp;
                <strong>Obteniendo datos...</strong>
              </div>
            </template>

            <template #cell(created)="data">
            <span>
              {{
                new Date(data.value).toLocaleString('pe-PE', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  localeMatcher: 'best fit',
                  hour: '2-digit',
                  minute: '2-digit',
                  timeZone: 'America/Lima'
                })
              }}
            </span>
            </template>

          </b-table>
          <b-col sm="12"  align="center" style="margin-top:-10px; margin-bottom:5px;">
            <span class="font-weight-bolder font-small-4" style=" vertical-align: -webkit-baseline-middle!important;">{{`Detalle de registros - Total: ${this.items.length}` }}</span>
          </b-col>
        </b-card>
      </b-col>
      <b-col sm="12" md="7">

        <!-- Grafico Lineal -->
        <b-card no-body>
          <b-card-body class="px-1 pb-0 pt-4 contenedor_grafico">
              <h4 style="text-align:center; margin-top:25px; margin-bottom:40px;">Distribución Rango de días y % Cumplimiento</h4>
              <div class="grafico_lineal" id="chartdiv" ref="chartdiv"></div>
              <div class="ocultador"></div>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

  </div>
</template>

<script>

import axiosIns from '../../../libs/axios'
import vSelect from 'vue-select'
import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BFormFile,
  VBModal,
  BTooltip,
  BInputGroup,
  BFormDatepicker,
  BFormTimepicker,
  BInputGroupAppend,
  BInputGroupPrepend, BFormTextarea, BLink, BButtonGroup,
  BAlert, VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, double, max, between, integer } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

let digitos_fecha = { year: 'numeric', month: '2-digit', day: '2-digit' };
let fecha_hoy=new Date()
//Formateo fecha_hoy
let fecha_actual = fecha_hoy.toLocaleDateString('es-ES', digitos_fecha).split('/')
fecha_actual=fecha_actual[2]+'-'+fecha_actual[1]+'-'+fecha_actual[0]

export default {
  components: {
    BCard,
    AppEchartLine,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    VBModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BFormFile,
    BTooltip,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    BLink,
    BFormDatepicker,
    BFormTimepicker,
    BButtonGroup,
    BAlert,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  data: () => ({
    id_user: JSON.parse(localStorage.getItem('userData')).id,

    dias: null,
    fecha_inicio:'',
    fecha_fin:'',
    conta:0,
    promedios:[],
    evento:'',
    labels:'',
    name:'HolaMundo',
    root_grafico: null,

    opcioness: {
      xAxisData:[],
      series: [],
    },

    modal_registro_entrega: false,
    modal_registro_devolucion: false,
    loadingEST: false,

    submittedNames: [],
    loading: false,
    loading2: false,
    loading3:false,
    loadingBP: false,
    loadingDE: false,
    loadingIMP: false,
    loadingEDI: false,

    loadingSAC: false,
    loadingSSC: false,
    loadingSSM: false,
    loadingSAM: false,
    loadingSAD: false,
    loadingSSD: false,

    estadoModalEditar: false,
    estadoModalImportar: false,
    estadoModalEstacion:false,
    estadoModalRespuesta: false,

    modalEditarEstadoShow: false,
    items: [],
    items_completo: [],
    perPage: 5,
    pageOptions: [5, 10, 15, 30],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: true,
    sortDirection: 'desc',
    filter: null,
    filter_sig: null,
    filterOn: ['accion'],
    fields: [
      {
        key: 'vr_dni',
        label: 'DNI',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vr_nombres',
        label: 'NOMBRES',
        class: 'text-nowrap text-left',
        sortable: true,
      },
      {
        key: 'vr_prom_cumplimento_cuadrilla',
        label: 'CUMPLIMIENTO',
        class: 'text-nowrap text-left',
        sortable: true,
      },
      {
        key: 'vr_prom_aprendizaje',
        label: 'APRENDIZAJE',
        class: 'text-nowrap text-left',
        sortable: true,
      },
      {
        key: 'vr_porcent_asistencia_rango',
        label: 'ASISTENCIA',
        class: 'text-nowrap text-left',
        sortable: true,
      },
      {
        key: 'vr_calculado_format',
        // label: 'HISTORICO DE DIAS LABORADOS',
        label: '% CALUCULO',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vr_categoria_grupo',
        // label: 'HISTORICO DE DIAS LABORADOS',
        label: 'Categoría Grupo',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vr_nro_dias_cosecha_historico',
        // label: 'HISTORICO DE DIAS LABORADOS',
        label: 'Día Lab Cosecha Hist.',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vr_clase',
        label: 'Clase',
        class: 'text-nowrap text-center',
        sortable: true,
      },
      {
        key: 'vr_estado_cosecha',
        label: 'Estado',
        class: 'text-nowrap text-center',
        sortable: true,
      },



    ],

    espanol:{
      labelNoTimeSelected: 'Seleccione Hora',
    },

    status_uno: [

      {
        0: 'Pendiente',
        1: 'Atendido',
        2: 'Aprobado',
        3: 'Desaprobado',
        4: 'Eliminado',
      },
      {
        0: 'light-info',
        1: 'light-success',
        2: 'light-warning',
        3: 'light-danger',
        4: 'light-dark',
      },

    ],

    status_dos: [
      {
        'E': 'Entregado',
        'R': 'Recepcionado',
      },
      {
        'E': 'light-danger',
        'R': 'light-warning',
      }
    ],


    estados: [
      {value: '0', text: "Pendiente"},
      {value: '1', text: "Atendido"},
    ],

    status: [
       {
        "NUEVO": 'light-warning',
        "ANTIGUO": 'light-info',
      }
    ],

    parametros_usuario: [],

    estado_aprobar: null,

    archivo_excel: null,
    empresas: [],
    cultivos: [],
    cultivosIMP: ['ARANDANO', 'ESPÁRRAGO', 'PALTA', 'UVA'],
    fundos: [],
    etapas: [],
    campos: [],
    turnos: [],
    codigos_h: [],
    parametros: [],

    dataEmpresa: [],
    dataLotesValvulas: [],
    notDuplicados: [],
    dataCompleta: [],

    spd: [],
    dia: null,
    hora: null,
    // -------

    comentario: null,

    semana_sig: null,
    inicioSemana_sig: null,
    finSemana_sig: null,

    mostrarSemAct: false,
    mostrarSemSgte: false,
    items_sem_act: [],
    items_sem_sgte: [],
    responsable: [],

    dataAutorizar:null,

    semanaActual: true,
    semanaEnviar: null,

    mostrarAlert: false,
    mostrarAlert2: false,

    respuestaRegistrosTotal: 0,
    respuestaErrores: [],

    // validation rules
    required,
    double,
    max,
    between,
    integer,
  }),
  computed: {},
  async mounted() {
    this.root_grafico=am5.Root.new("chartdiv");
    this.obtenerHistorialCosechadores()

    localize("es");

  },

  methods: {

    dibujarGrafico(){

      const yo=this;
      console.log("DIBUJANDO EL GRAFICO...")
      console.log(yo.promedios)

      yo.root_grafico.container.children.clear();
      // yo.root_grafico.dispose();

      am5.ready(function() {

      var data=[];
      var data = yo.promedios

      console.log("Imprimiendo data")
      console.log(data)

      yo.root_grafico.setThemes([
        am5themes_Animated.new(yo.root_grafico)
      ]);

          // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      var chart = yo.root_grafico.container.children.push(
           am5xy.XYChart.new(yo.root_grafico, {
             panX: false,
             panY: false,
             wheelX: "panX",
             wheelY: "zoomX",
             layout: yo.root_grafico.verticalLayout
           })
      );


        // Add scrollbar
        // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
        chart.set(
            "scrollbarX",
            am5.Scrollbar.new(yo.root_grafico, {
              orientation: "horizontal"
            })
        );




        // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/

        var xRenderer = am5xy.AxisRendererX.new(yo.root_grafico, {});
        var xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(yo.root_grafico, {
              categoryField: "year",
              renderer: xRenderer,
              tooltip: am5.Tooltip.new(yo.root_grafico, {})
            })
        );
        xRenderer.grid.template.setAll({
          location: 1
        })

        xAxis.data.setAll(data);

        var yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(yo.root_grafico, {
              min: 0,
              extraMax: 0.1,
              renderer: am5xy.AxisRendererY.new(yo.root_grafico, {
                strokeOpacity: 0.1
              })
            })
        );




        //var xRenderer = am5xy.AxisRendererX.new(yo.root_grafico, {
        //minGridDistance: 50
      //});

        // Add series
// https://www.amcharts.com/docs/v5/charts/xy-chart/series/

        var series1 = chart.series.push(
            am5xy.ColumnSeries.new(yo.root_grafico, {
              name: "Día Cosecha",
              xAxis: xAxis,
              yAxis: yAxis,
              valueYField: "income",
              categoryXField: "year",
              tooltip: am5.Tooltip.new(yo.root_grafico, {
                pointerOrientation: "horizontal",
                labelText: "{name} in {categoryX}: {valueY} {info}"
              })
            })
        );

        series1.columns.template.setAll({
          tooltipY: am5.percent(10),
          templateField: "columnSettings"
        });

        series1.data.setAll(data);

        var series2 = chart.series.push(
            am5xy.LineSeries.new(yo.root_grafico, {
              name: "Cumplimiento",
              xAxis: xAxis,
              yAxis: yAxis,
              valueYField: "expenses",
              categoryXField: "year",
              tooltip: am5.Tooltip.new(yo.root_grafico, {
                pointerOrientation: "horizontal",
                labelText: "{name} in {categoryX}: {valueY} {info}"
              })
            })
        );

        series2.strokes.template.setAll({
          strokeWidth: 3,
          templateField: "strokeSettings"
        });


        series2.data.setAll(data);

        series2.bullets.push(function() {
          return am5.Bullet.new(yo.root_grafico, {
            sprite: am5.Circle.new(yo.root_grafico, {
              strokeWidth: 3,
              stroke: series2.get("stroke"),
              radius: 5,
              fill: yo.root_grafico.interfaceColors.get("background")
            })
          });
        });

        chart.set("cursor", am5xy.XYCursor.new(yo.root_grafico, {}));

// Add legend
// https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
        var legend = chart.children.push(
            am5.Legend.new(yo.root_grafico, {
              centerX: am5.p50,
              x: am5.p50
            })
        );
        legend.data.setAll(chart.series.values);

// Make stuff animate on load
// https://www.amcharts.com/docs/v5/concepts/animations/
        chart.appear(1000, 100);
        series1.appear();



      }); // end am5.ready()

      console.log(yo.$refs.chartdiv)
      console.log(yo.root_grafico)



    },

    beforeDestroy() {
      if (this.root) {
        this.root.dispose();
      }
    },

    obtenerHistorialCosechadores(){

      const yo=this
      yo.loading=true
      console.log("OBTENIENDO REGISTROS DE HISTORIAL COSECHADORES")

      // yo.opcioness.xAxisData=[]
      // yo.opcioness.series=[]

      if (yo.fecha_inicio != '' && yo.fecha_fin != '' ){
        const data = JSON.stringify(
            {
              "fecha_inicio": yo.fecha_inicio,
              "fecha_fin":yo.fecha_fin
            }
        )

        const config={
          method: 'post',
          url: '/cosecha/cosecha/historial_dias_experiencia/',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          data:data
        }

        axiosIns(config)
            .then(function(response){
              if(response.status==200){
                console.log("LLENANDO")

                console.log(response.data['promedios'])

                yo.opcioness.xAxisData=[]
                yo.opcioness.series=[]
                // yo.conta++
                console.log(response.data)

                yo.items = response.data['response'];
                yo.totalRows = yo.items.length

                let z=0


                console.log("T")
                console.log(yo.opcioness.series)
                console.log(yo.$refs.graf_lin)

                yo.promedios=[]
                yo.promedios=response.data['promedios']
                yo.dibujarGrafico();


              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function (){
              yo.loading = false
            });
      }else {
        yo.loading = false
      }



    },

    actualizarEstacion(){
      console.log("ACTUALIZANDO ESTACION")
      const yo=this

      if (yo.estacion ==''){
        yo.loadingEST=false
      }else{
        yo.loadingEST=true
      }

      document.getElementById('n_estacion').innerHTML=this.estacion
    },

    dataInicial(){
      const spd = this.numeroDeSemana(new Date())
      this.semana = spd.n_semana.toString().padStart(2, '0')
      this.inicioSemana = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.semana_sig = spd.n_semana === 52 ? '01' : (spd.n_semana + 1).toString().padStart(2, '0')
      // this.semana_sig = spd.n_semana + 1
      spd.inicio.setDate(spd.inicio.getDate() + 7)
      spd.fin.setDate(spd.fin.getDate() + 7)

      this.inicioSemana_sig = spd.inicio.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })
      this.finSemana_sig = spd.fin.toLocaleString('pe-PE', {
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        localeMatcher: 'best fit',
        timeZone: 'America/Lima'
      })

      this.filter = this.semana
      this.filter_sig = this.semana_sig

    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    handleOkRecepcion(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarRecepcion()
    },

    handleOkEntrega(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.registrarEntrega()
    },

    validarRegistroEditar(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.editarRegistro()
    },

    importarOk(bvModalEvtImp) {
      // Prevent modal from closing
      bvModalEvtImp.preventDefault()
      // Trigger submit handler
      this.enviarFile()
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    numeroDeSemana(fecha){
      const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

      // fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()+7));
      fecha = new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));

      let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
      if (diaDeLaSemana === 0) {
        diaDeLaSemana = 7;
      }

      fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

      const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

      const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

      return {
        n_semana: Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA),
        inicio: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() - fecha.getDay() + 1),
        fin: new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate() + 7 - fecha.getDay()),
      }

    },

    asignarInicioFinSemana(){
      this.inicioSemana = ''
      this.finSemana = ''

      if (this.semana >= 1 && this.semana <= 52){
        const hoy = new Date()
        const fech = new Date(Date.UTC(hoy.getFullYear(), 0, 1));

        fech.setDate(fech.getDate() + (this.semana*7));

        const inicio = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() - fech.getDay() + 1)
        const fin = new Date(fech.getFullYear(), fech.getMonth(), fech.getDate() + 7 - fech.getDay())

        this.inicioSemana = inicio.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
        this.finSemana = fin.toLocaleString('pe-PE', {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
          localeMatcher: 'best fit',
          timeZone: 'America/Lima'
        })
      }
    },

    autorizar(data){
      this.estado_aprobar = null

      if(data['estado'] === '0'){
        this.modalEditarEstadoShow = true
        this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
      }else{
        if(this.responsable[0].rol === 'USUARIO'){
          this.mostrarNotificacion('Advertencia', 'BellIcon', "Solo se pueden seleccionar los registro con aprobación pendiente.", 'warning', 6000)
        }else{
          this.modalEditarEstadoShow = true
          this.dataAutorizar = data.semana + "*" + data.cultivo + "*" + data.empresa + "*" + data.fundo + "*" + data.version
        }
      }
    },

    verDetalle(datos){
      console.log(datos)
      const yo = this
      yo.items_sem_act = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemAct = true
    },

    verDetalleSemSgte(datos){
      const yo = this
      yo.items_sem_sgte = yo.spd.filter(invoice => invoice.semana+invoice.cultivo+invoice.empresa+invoice.fundo === datos.semana+datos.cultivo+datos.empresa+datos.fundo)

      yo.mostrarSemSgte = true
    },

    descargarPlantilla(){
      const yo = this
      const config = {
        method: 'get',
        url: '/cosecha/fertilizacion/plantilla/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer'
      }

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {

              const fileURL = window.URL.createObjectURL(new Blob([response.data]))
              const fileLink = document.createElement('a')
              fileLink.href = fileURL;
              fileLink.setAttribute('download', 'Plantilla_PRG_AGR.xlsx');
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          });
    },

    filtros(){
      this.items = this.spd
      this.items = this.items.filter(
          invoice =>
              invoice.empresa === (this.empresaFiltro || invoice.empresa) &&
              invoice.semana === (this.semanaFiltro || invoice.semana) &&
              invoice.cultivo === (this.cultivoFiltro || invoice.cultivo)
      )
      this.totalRows = this.items.length
    },

    modal_registro(valor){
      console.log("SSSSSSSSSSSSSSSS")
      const yo = this

      console.log(valor)

      if(valor==true){
        yo.modal_registro_entrega=true
      }else{
        yo.modal_registro_devolucion=true
      }

    },


    descargarRegistros(){
      const yo = this

      yo.loading2=true

      const data = JSON.stringify(
          {
            "datos": yo.items
          }
      )

      const config = {
        method: 'post',
        url: '/cosecha/cosecha/historial_cosechadores/exportarExcel/',
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'arraybuffer',
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "HIST_COSECHADORES_"+ yo.fecha_inicio +".xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Archivo creado',
                      icon: 'CheckIcon',
                      text: 'El archivo se creó satisfactoriamente.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loading2=false
          });
    },


    descargarPdf(){
      const yo=this
      yo.loading3=true
      const nombre_archivo='HISTORIAL COSECHADORES '+yo.fecha_inicio.toString()+' AL '+yo.fecha_fin.toString()
      // const nombre_archivo='HISTORIAL COSECHADORES'

      const data=JSON.stringify(
        {
          'datos': yo.items,
        }
      )

      const config={
        method:'post',
        url:'/cosecha/cosecha/historial_cosechadores/exportarPdf/',
        headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
      }

      axiosIns(config)
        .then(function(response){
          if(response.status===200){
            console.log("RSPTA GOOD")
            var pdf_url = URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
            // window.open(pdf_url);
            const link = document.createElement('a');
            link.href = pdf_url;
            link.setAttribute('download', nombre_archivo+'.pdf');
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          yo.loading3=false
        });
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: '';
}


.tablaferti{
  min-height: 52vh!important;
}

.tablaferti::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablaferti::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablaferti::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

.contenedor_estacion{
  position:absolute;
  right:0;
  top: 110px;
  z-index:15;
  font-size:18px;
  font-weight:bold
}

//Para ocultarle el boton de cerrar al modal cuando se aperturael modulo
#modal-seleccionar-estacion .close,
.vs__clear{
  display:none
}

.align-right-modal .modal-dialog {
  position: absolute;
  top:15%;
  right: 5%;
}

.align-left-modal .modal-dialog {
  position: absolute;
  top:15%;
  left: 10%;
}

.custom-modal-style .modal-content {
  background-color: transparent;
  box-shadow: none;
}

.modal-backdrop{
  z-index:0;
  width: 0;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .grafico_lineal {
    width: 100%;
    /* height: 410px; */
    height: 536px;
  }

  .contenedor_grafico{
    position:relative
  }

</style>
